import { createContext, useContext, useState, useCallback } from "react";
import { COURSES } from "../data/courses";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  // ── Course catalog (admin can add/edit) ──────────────────────────────────
  const [courses, setCourses] = useState(COURSES);

  // ── Cart ─────────────────────────────────────────────────────────────────
  const [cart, setCart] = useState([]);

  const addToCart = useCallback((course) => {
    setCart((prev) =>
      prev.find((c) => c.id === course.id) ? prev : [...prev, course]
    );
  }, []);

  const removeFromCart = useCallback((id) => {
    setCart((prev) => prev.filter((c) => c.id !== id));
  }, []);

  const clearCart = useCallback(() => setCart([]), []);

  const cartTotal = cart.reduce((sum, c) => sum + c.price, 0);

  // ── Checkout flow state ──────────────────────────────────────────────────
  const [checkoutStep, setCheckoutStep] = useState("contact"); // contact | otp | payment | success
  const [buyerInfo, setBuyerInfo] = useState({ phone: "", email: "" });
  const [orderId, setOrderId] = useState(null);

  // ── Admin ────────────────────────────────────────────────────────────────
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);

  const adminLogin = (password) => {
    if (password === "admin@123") { setIsAdminLoggedIn(true); return true; }
    return false;
  };
  const adminLogout = () => setIsAdminLoggedIn(false);

  const addCourse = (course) => {
    setCourses((prev) => [
      ...prev,
      { ...course, id: Date.now(), reviews: 0, rating: 5.0, featured: false },
    ]);
  };

  const updateCourse = (id, updates) => {
    setCourses((prev) => prev.map((c) => (c.id === id ? { ...c, ...updates } : c)));
  };

  const deleteCourse = (id) => {
    setCourses((prev) => prev.filter((c) => c.id !== id));
  };

  const toggleFeatured = (id) => {
    setCourses((prev) =>
      prev.map((c) => (c.id === id ? { ...c, featured: !c.featured } : c))
    );
  };

  return (
    <AppContext.Provider
      value={{
        courses, addCourse, updateCourse, deleteCourse, toggleFeatured,
        cart, addToCart, removeFromCart, clearCart, cartTotal,
        checkoutStep, setCheckoutStep,
        buyerInfo, setBuyerInfo,
        orderId, setOrderId,
        isAdminLoggedIn, adminLogin, adminLogout,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used inside AppProvider");
  return ctx;
};
